<section class="mainTopBanner" role="main">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">AI-assisted Writing</h1>
                        <h2 class="text-white">Never Get Stuck <br class="d-lg-block d-none"/>While Writing</h2>
                        <p class="text-white">With Trinka, AI and writing go hand in hand— Ask Trinka to start writing from scratch, improve an idea, or let AI continue where you left off.</p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=GB" class="white-btn" target="_blank" aria-labelledby="ai-writing-cta" rel="noopener noreferrer">Get Started</a>
                        </div>
                        <p id="ai-writing-cta" class="sr-only">
                            Get Started with AI-assisted Writing
                        </p>
                        
                    </div>
                    <div class="top-banner-right">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true">
                            <source src="../../../../../assets/images/features/ai-studio/ai-ask.mp4#t=0.1" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                        <!-- <img src="../../../../assets/images/features/ai-studio/Ask Feature Page_Main comp_3 (1).gif" alt="ai apps library" /> -->
                        <span class="shape"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="apps-library-banner">
        <div class="app-inner">
        </div>
    </div>
</section>

<section class="section-pd bg-light">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-9">
                <div class="trinka-title mb-0 text-center">
                    <h2>What is AI-assisted Writing <br class="d-lg-block d-none" />in Trinka</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">The AI-assisted Writing feature, activated by typing <span class="ask">/ask</span>, <br class="d-lg-block d-none" />seamlessly integrates generative AI into the writing process, enhancing user experience and productivity with intelligent, context-aware text generation and refinements.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Why Choose AI-assisted Writing</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <div class="features_cards_icon">
                        <img src="/assets/images/features/ai-studio/icons/writer-block.svg" class="h-auto" width="48" height="49" alt="Avoid Writer's Block" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>Avoid Writer's Block</h3>
                        <p>Not sure how to finish the sentence, or stuck mid-way? Ask Trinka to keep writing content that is relevant and context-specific to overcome writer's block.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <div class="features_cards_icon">
                        <img src="/assets/images/features/ai-studio/icons/word-conversion.svg" class="h-auto" width="48" height="49" alt="Convert Ideas into Words" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>Convert Ideas into Words</h3>
                        <p>Not sure where or how to start writing? Ask Trinka to start from scratch. Convert Ideas and thoughts into high-quality polished content. </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <div class="features_cards_icon">
                        <img src="/assets/images/features/ai-studio/icons/content-quality.svg" class="h-auto" width="48" height="49" alt="content quality" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>Improve Content Quality</h3>
                        <p>Polish your text to make it fluent, clear, and adjust the tone and voice to ensure it is suitable for your audience.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>What Can You Do with Trinka's <br class="d-md-block d-none"/>AI-assisted Writing?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="c-card key-features-left">
                    <div id="accordion_free" class="accordion">
                        <div class="card" [ngClass]="freeshowTab == 1 ? 'active' : ' '">
                            <div class="card-header">
                                <a class="card-link" (click)="freeScore(1)" data-toggle="collapse" href="#freecollapseOne">
                                    <span><img src="/assets/images/features/ai-studio/icons/icon1.svg" alt="text icon" /></span>
                                    Contextual Writing
                                </a>
                            </div>
                            <div id="freecollapseOne" class="collapse show" data-parent="#accordion_free">
                                <div class="card-body">
                                    <p>When you ask Trinka to "Keep Writing," it understands the context of your sentence and paragraph, generating text that helps you complete the writing.</p>
                                </div>
                            </div>
                        </div>
                      
                        <div class="card" [ngClass]="freeshowTab == 2 ? 'active' : ' '">
                            <div class="card-header">
                                <a class="collapsed card-link" (click)="freeScore(2)" data-toggle="collapse" href="#freecollapseTwo">
                                    <span><img src="/assets/images/features/ai-studio/icons/icon2.svg" alt="similar sources" /></span>
                                    Write from Scratch
                                </a>
                            </div>
                            <div id="freecollapseTwo" class="collapse" data-parent="#accordion_free">
                                <div class="card-body">
                                    <p>Not sure how to start? Just Ask Trinka to "Write a Paragraph" or "Create an Outline" to help you get started.</p>
                                </div>
                            </div>
                        </div>
                      
                        <div class="card" [ngClass]="freeshowTab == 3 ? 'active' : ' '">
                            <div class="card-header">
                                <a class="collapsed card-link" (click)="freeScore(3)" data-toggle="collapse" href="#freecollapseThree">
                                    <span><img src="/assets/images/features/ai-studio/icons/icon3.svg" alt="global" /></span>
                                    Rewrite
                                </a>
                            </div>
                            <div id="freecollapseThree" class="collapse" data-parent="#accordion_free">
                                <div class="card-body">
                                    <p>Need to improve your writing? Ask Trinka to make it fluent, clear, concise or just paraphrase it for a more powerful impactful.</p>
                                </div>
                            </div>
                        </div>

                        <div class="card" [ngClass]="freeshowTab == 4 ? 'active' : ' '">
                            <div class="card-header">
                                <a class="collapsed card-link" (click)="freeScore(4)" data-toggle="collapse" href="#freecollapseFour">
                                    <span><img src="/assets/images/features/ai-studio/icons/icon4.svg" alt="global" /></span>
                                    Argument Analyzer
                                </a>
                            </div>
                            <div id="freecollapseFour" class="collapse" data-parent="#accordion_free">
                                <div class="card-body">
                                    <p>Ask Trinka to analyze arguments by strengthening them, identifying assumptions, and crafting insightful critiques.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 dflex">
                <div class="c-card key-features-right">
                    <div class="image" [ngClass]="freeshowTab == 1 ? 'show' : ''">
                        <img src="../../../../../assets/images/features/ai-studio/keep-writing.webp" class="img-fluid" alt="contextual wrtiting" loading="lazy" />
                    </div>
                    <div class="image" [ngClass]="freeshowTab == 2 ? 'show' : ''">
                        <img src="../../../../../assets/images/features/ai-studio/start-writing.webp" class="img-fluid" alt="start writing" loading="lazy" />
                    </div>
                    <div class="image" [ngClass]="freeshowTab == 3 ? 'show' : ''">
                        <img src="../../../../../assets/images/features/ai-studio/rewrite.webp" class="img-fluid" alt="rewrite" loading="lazy" />
                    </div>
                    <div class="image" [ngClass]="freeshowTab == 4 ? 'show' : ''">
                        <img src="../../../../../assets/images/features/ai-studio/argument-analyzer.webp" class="img-fluid" alt="argument analyzer" loading="lazy" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2" #viewVideo>
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                        <img src="/assets/images/features/ai-studio/ask-trinka-thumbnail.webp" alt="ask trinka thumbnail" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>See How It Works</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <ol class="ai-list">
                            <li>Open your file in the Editor</li>
                            <li>Type "/ask" or select a sentence to open the prompt menu</li>
                            <li>Select from in-built prompts or write your own</li>
                        </ol>
                        <p id="faq-info">Have more questions? Browse through our FAQs <a (click)="scroll(target)" class="text-link" aria-labelledby="faq-info" style="cursor: pointer;">here</a>.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="suitableForSection section-pd">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h2>Suitable For</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-4 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                            <path d="M27.4833 3.33331H13.5167C7.45001 3.33331 3.83334 6.94998 3.83334 13.0166V26.9833C3.83334 31.6666 5.98334 34.8833 9.76668 36.1C10.8667 36.4833 12.1333 36.6666 13.5167 36.6666H27.4833C28.8667 36.6666 30.1333 36.4833 31.2333 36.1C35.0167 34.8833 37.1667 31.6666 37.1667 26.9833V13.0166C37.1667 6.94998 33.55 3.33331 27.4833 3.33331ZM34.6667 26.9833C34.6667 30.55 33.2667 32.8 30.45 33.7333C28.8333 30.55 25 28.2833 20.5 28.2833C16 28.2833 12.1833 30.5333 10.55 33.7333H10.5333C7.75001 32.8333 6.33334 30.5666 6.33334 27V13.0166C6.33334 8.31665 8.81668 5.83331 13.5167 5.83331H27.4833C32.1833 5.83331 34.6667 8.31665 34.6667 13.0166V26.9833Z" fill="#763393"/>
                            <path d="M20.5 13.3333C17.2 13.3333 14.5334 16 14.5334 19.3C14.5334 22.6 17.2 25.2833 20.5 25.2833C23.8 25.2833 26.4667 22.6 26.4667 19.3C26.4667 16 23.8 13.3333 20.5 13.3333Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h4>Academicians and Researchers</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M36.1056 8.34517L20.4134 3.06772C20.145 2.97743 19.8547 2.97743 19.5863 3.06772L3.89413 8.34517C3.63374 8.43275 3.40727 8.60077 3.2468 8.82542C3.08632 9.05008 2.99998 9.31999 3 9.59692V22.7906C3 23.1405 3.13777 23.4761 3.38301 23.7235C3.62825 23.9709 3.96086 24.1099 4.30768 24.1099C4.6545 24.1099 4.98711 23.9709 5.23235 23.7235C5.47759 23.4761 5.61536 23.1405 5.61536 22.7906V11.4275L11.106 13.273C9.6472 15.6508 9.18331 18.5156 9.81618 21.2382C10.4491 23.9608 12.1269 26.3187 14.4814 27.7942C11.5392 28.9586 8.99572 31.0646 7.13554 33.9441C7.0388 34.0892 6.9716 34.2522 6.93785 34.4237C6.90411 34.5952 6.90449 34.7718 6.93897 34.9431C6.97345 35.1145 7.04134 35.2772 7.1387 35.4219C7.23607 35.5665 7.36095 35.6902 7.50611 35.7857C7.65126 35.8812 7.81379 35.9467 7.98424 35.9783C8.15469 36.0099 8.32966 36.007 8.49899 35.9697C8.66831 35.9325 8.82862 35.8617 8.97057 35.7614C9.11253 35.6611 9.23332 35.5333 9.32591 35.3855C11.7893 31.5726 15.6796 29.3874 19.9999 29.3874C24.3201 29.3874 28.2105 31.5726 30.6738 35.3855C30.8656 35.6731 31.1619 35.873 31.4986 35.942C31.8353 36.011 32.1854 35.9435 32.4732 35.7541C32.7609 35.5647 32.9633 35.2687 33.0364 34.93C33.1096 34.5913 33.0477 34.2372 32.8642 33.9441C31.004 31.0646 28.4507 28.9586 25.5183 27.7942C27.8705 26.3188 29.5468 23.9624 30.1796 21.2418C30.8123 18.5211 30.3499 15.6584 28.8937 13.2812L36.1056 10.8569C36.366 10.7694 36.5926 10.6014 36.7531 10.3767C36.9136 10.1521 37 9.88212 37 9.60516C37 9.3282 36.9136 9.05827 36.7531 8.8336C36.5926 8.60894 36.366 8.44094 36.1056 8.35342V8.34517ZM27.8459 18.8325C27.8463 20.084 27.5525 21.3177 26.9888 22.4325C26.425 23.5473 25.6073 24.5113 24.6028 25.2455C23.5982 25.9797 22.4355 26.4632 21.2099 26.6562C19.9843 26.8492 18.7308 26.7463 17.5523 26.3559C16.3738 25.9655 15.3038 25.2987 14.4301 24.4103C13.5564 23.5219 12.904 22.4371 12.5263 21.245C12.1486 20.0529 12.0565 18.7875 12.2574 17.5525C12.4583 16.3175 12.9466 15.1482 13.6821 14.1405L19.5863 16.1195C19.8547 16.2098 20.145 16.2098 20.4134 16.1195L26.3176 14.1405C27.3111 15.4994 27.8467 17.1438 27.8459 18.8325Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h4>Students</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <path d="M15 3.33331C10.6333 3.33331 7.08333 6.88331 7.08333 11.25C7.08333 15.5333 10.4333 19 14.8 19.15C14.9333 19.1333 15.0667 19.1333 15.1667 19.15C15.2 19.15 15.2167 19.15 15.25 19.15C15.2667 19.15 15.2667 19.15 15.2833 19.15C19.55 19 22.9 15.5333 22.9167 11.25C22.9167 6.88331 19.3667 3.33331 15 3.33331Z" fill="#763393"/>
                            <path d="M23.4667 23.5833C18.8167 20.4833 11.2333 20.4833 6.55 23.5833C4.43333 25 3.26666 26.9166 3.26666 28.9666C3.26666 31.0166 4.43333 32.9166 6.53333 34.3166C8.86666 35.8833 11.9333 36.6666 15 36.6666C18.0667 36.6666 21.1333 35.8833 23.4667 34.3166C25.5667 32.9 26.7333 31 26.7333 28.9333C26.7167 26.8833 25.5667 24.9833 23.4667 23.5833Z" fill="#763393"/>
                            <path d="M33.3167 12.2334C33.5833 15.4667 31.2833 18.3 28.1 18.6834C28.0833 18.6834 28.0833 18.6834 28.0667 18.6834H28.0167C27.9167 18.6834 27.8167 18.6834 27.7333 18.7167C26.1167 18.8 24.6333 18.2834 23.5167 17.3334C25.2333 15.8 26.2167 13.5 26.0167 11C25.9 9.65002 25.4333 8.41669 24.7333 7.36669C25.3667 7.05002 26.1 6.85002 26.85 6.78336C30.1167 6.50002 33.0333 8.93336 33.3167 12.2334Z" fill="#763393"/>
                            <path d="M36.65 27.65C36.5167 29.2667 35.4833 30.6667 33.75 31.6167C32.0833 32.5334 29.9833 32.9667 27.9 32.9167C29.1 31.8334 29.8 30.4834 29.9333 29.05C30.1 26.9834 29.1167 25 27.15 23.4167C26.0333 22.5334 24.7333 21.8334 23.3167 21.3167C27 20.25 31.6333 20.9667 34.4833 23.2667C36.0167 24.5 36.8 26.05 36.65 27.65Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h4>Content Creators and Marketers</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                            <path d="M35.5 36.6666H5.5C4.81667 36.6666 4.25 36.1 4.25 35.4166C4.25 34.7333 4.81667 34.1666 5.5 34.1666H35.5C36.1833 34.1666 36.75 34.7333 36.75 35.4166C36.75 36.1 36.1833 36.6666 35.5 36.6666Z" fill="#763393"/>
                            <path d="M32.2 5.79998C28.9667 2.56664 25.8 2.48331 22.4833 5.79998L20.4667 7.81664C20.3 7.98331 20.2333 8.24998 20.3 8.48331C21.5667 12.9 25.1 16.4333 29.5167 17.7C29.5833 17.7166 29.65 17.7333 29.7167 17.7333C29.9 17.7333 30.0667 17.6666 30.2 17.5333L32.2 15.5166C33.85 13.8833 34.65 12.3 34.65 10.7C34.6667 9.04998 33.8667 7.44998 32.2 5.79998Z" fill="#763393"/>
                            <path d="M26.5167 19.2167C26.0333 18.9834 25.5667 18.75 25.1167 18.4834C24.75 18.2667 24.4 18.0334 24.05 17.7834C23.7667 17.6 23.4333 17.3334 23.1167 17.0667C23.0833 17.05 22.9667 16.95 22.8333 16.8167C22.2833 16.35 21.6667 15.75 21.1167 15.0834C21.0667 15.05 20.9833 14.9334 20.8667 14.7834C20.7 14.5834 20.4167 14.25 20.1667 13.8667C19.9667 13.6167 19.7333 13.25 19.5167 12.8834C19.25 12.4334 19.0167 11.9834 18.7833 11.5167C18.6716 11.2773 18.5713 11.0417 18.4789 10.8117C18.3429 10.4735 17.9062 10.3771 17.6485 10.6349L7.73333 20.55C7.51666 20.7667 7.31666 21.1834 7.26666 21.4667L6.36666 27.85C6.19999 28.9834 6.51666 30.05 7.21666 30.7667C7.81666 31.35 8.64999 31.6667 9.54999 31.6667C9.74999 31.6667 9.94999 31.65 10.15 31.6167L16.55 30.7167C16.85 30.6667 17.2667 30.4667 17.4667 30.25L27.3746 20.3421C27.6342 20.0825 27.5355 19.6393 27.1952 19.5017C26.9754 19.4129 26.7516 19.3185 26.5167 19.2167Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h4>Professional Writers <br class="d-lg-block d-none"/>and Editors</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg fill="#763393" width="40px" height="40px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"></path></g></svg>
                    </div>
                    <div class="media-body">
                        <h4>Institutions & Universities</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M15 2H17C18.8856 2 19.8284 2 20.4142 2.58579C21 3.17157 21 4.11438 21 6V21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H3V9C3 7.11438 3 6.17157 3.58579 5.58579C4.17157 5 5.11438 5 7 5H11C12.8856 5 13.8284 5 14.4142 5.58579C15 6.17157 15 7.11438 15 9V21.25H16.5V9L16.5 8.91051C16.5001 8.04488 16.5002 7.25121 16.4134 6.60559C16.3178 5.89462 16.0929 5.14317 15.4749 4.52513C14.8568 3.90708 14.1054 3.68219 13.3944 3.5866C12.7579 3.50102 11.9774 3.49991 11.126 3.49999C11.2103 3.11275 11.351 2.82059 11.5858 2.58579C12.1716 2 13.1144 2 15 2ZM5.25 8C5.25 7.58579 5.58579 7.25 6 7.25H12C12.4142 7.25 12.75 7.58579 12.75 8C12.75 8.41421 12.4142 8.75 12 8.75H6C5.58579 8.75 5.25 8.41421 5.25 8ZM5.25 11C5.25 10.5858 5.58579 10.25 6 10.25H12C12.4142 10.25 12.75 10.5858 12.75 11C12.75 11.4142 12.4142 11.75 12 11.75H6C5.58579 11.75 5.25 11.4142 5.25 11ZM5.25 14C5.25 13.5858 5.58579 13.25 6 13.25H12C12.4142 13.25 12.75 13.5858 12.75 14C12.75 14.4142 12.4142 14.75 12 14.75H6C5.58579 14.75 5.25 14.4142 5.25 14ZM9 18.25C9.41421 18.25 9.75 18.5858 9.75 19V21.25H8.25V19C8.25 18.5858 8.58579 18.25 9 18.25Z" fill="#763393"></path> </g></svg>

                    </div>
                    <div class="media-body">
                        <h4>Enterprises</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-security-section></app-security-section>

<section class="custom-ai-gradient-light section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center mb-40">
                    <h2 class="mb-4">
                        Complete Your Drafts Quickly and Meet the Submissions Deadlines Faster.
                    </h2>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=GB" class="filled-btn" target="_blank" rel="noopener noreferrer">Get Started</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Frequently Asked Questions</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        What is AI assisted writing?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>AI-assisted writing is the use of artificial intelligence to help generate, refine, and enhance written content. It provides real-time suggestions, corrections, and content generation based on context, making writing faster and more efficient. <b>Trinka’s AI-assisted Writing</b> feature allows users to generate text, expand ideas, and refine their writing seamlessly using AI, ensuring clarity, coherence, and proper grammar.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        How can I use Trinka's AI-assisted Writing feature?
                                    </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's AI-assisted Writing is a generative AI tool that integrates seamlessly into your writing process. By typing <b>/ask</b>, you can prompt Trinka to generate context-aware text, helping you start from scratch, develop ideas, or continue from where you left off. Alternatively, you can select any existing text, click the AI sparkles icon, and choose from the available options. </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        What type of content can Trinka’s AI-assisted writing tool create?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka’s AI-assisted writing tool helps you brainstorm ideas, create outlines, paragraphs, critiques, blog post, and draft research documents effortlessly. It can generate AI-powered content for articles, arguments, critiques, blogs, captions, and more—providing ready-to-review text in seconds.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Who can use Trinka’s Generative AI writing feature?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka’s AI writing feature is available in all plans. Basic users have limited monthly requests whereas the Premium Plus plan provides higher usage. For more details, please visit our <a href="/pricing" target="_blank" rel="noopener noreferrer">pricing</a> page. </p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        How can AI-assisted Writing help me overcome writer's block?
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>If you're unsure how to proceed with a sentence or paragraph, you can use the /ask command to have Trinka generate relevant content, assisting you in overcoming writer's block and maintaining your writing flow.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        How does Trinka ensure the generated content is contextually relevant?
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka AI analyzes the context of your existing text and the prompts you provide to generate content that aligns with your writing's subject matter and tone, ensuring coherence and relevance.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        Is my data secure when using Trinka's AI-assisted Writing?
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka prioritizes data privacy and security. Your data is encrypted and not shared with third parties, ensuring your writing remains confidential. The LLMs are self-hosted and hence do not share your private data with anyone. Our Premium and Sensitive Data plans provide higher privacy with real-time data deletion. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close" (click)="stopAllVideos()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/g5plTV60YSg?si=L2uv8Hvtfe_tiEav"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
            </div>
        </div>
    </div>
</div>